import { ContentChild, Directive, Injector, Input } from "@angular/core";
import { BfxFieldDirective } from "./bfx-field";
import { EmphasisMixinInputs } from "./mixins/emphasis";
import { FieldStateMixinInputs } from "./mixins/field-state";
import { InputtedMixinInputs } from "./mixins/inputted";
import { SizeMixinInputs } from "./mixins/size";

const BFX_FIELD_SELECT_DIRECTIVE = "bfx-field-select";

@Directive({
  selector: `[${BFX_FIELD_SELECT_DIRECTIVE}]`,
  host: { class: "bfx-field-select-container" },
  exportAs: "bfxFieldSelect",
  inputs: [
    ...FieldStateMixinInputs,
    ...SizeMixinInputs,
    ...InputtedMixinInputs,
    ...EmphasisMixinInputs,
  ],
  standalone: false,
})
export class BfxFieldSelectDirective extends BfxFieldDirective {
  @Input(BFX_FIELD_SELECT_DIRECTIVE)
  directiveInput: Record<string, any>;

  directiveInputName = BFX_FIELD_SELECT_DIRECTIVE;

  constructor(injector: Injector) {
    super(injector);
  }
}
